import { useState } from "react";
import Cleave from "cleave.js/react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
export default function FilterForm({
    setCurrentPage, 
    setFilter,
    
    curFilter, 
    defaultFilter,  
    dataFrame, 

    width, 
    minWidth
}){
    const [showFilter, setShowFilterForm] = useState(false);
    return (
        <>
        <button
            type = "button"
            className = "headerButton"
            style = {{
                backgroundColor: Object.entries(curFilter).filter(([key, value]) => defaultFilter[key] !== value).length?
                "rgb(0,123,255)"
                :undefined
            }}
            onClick = {() => {setShowFilterForm(true)}}
        >
            Filter
        </button>
        {showFilter?
        <Modal 
            touchOutsideClose = {true} 
            closeIt = {() => setShowFilterForm(false)} 
            title = "Filter" 
            width = {width}
            minWidth = {minWidth}
        >
            <div className = "mt-3 mb-3">
                <button type = "button" className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</button>
            </div>
            {dataFrame.filter(elem => !elem.notFilterable).map((elem, itemIndex) => 
            <div key = {itemIndex} className = "mb-2 d-flex align-items-center">
                {["number", "date"].includes(elem.type)?
                <span className = "font-weight-bold">{elem.title}:</span>
                :
                <label htmlFor = {elem.filterKey || elem.key} className = "font-weight-bold">
                    {elem.title}:
                </label>
                }
                {["text", "textarea", "email", "file"].includes(elem.type)?
                <input
                    autoComplete = {elem.autoComplete}
                    id = {elem.filterKey || elem.key}
                    //type = {elem.type}
                    className = "form-control w-auto flex-grow-1 ml-3"
                    value = {curFilter[elem.filterKey || elem.key] ?? ""}
                    onChange = {event => {
                        setFilter({...curFilter, [elem.filterKey || elem.key]: event.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                :<></>}
                {elem.type === "phone"?
                <Cleave
                    id = {elem.filterKey || elem.key}
                    pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                    className = "form-control flex-grow-1 ml-3"  
                    value = {curFilter[elem.key] ?? ""}
                    onChange = {event => {
                        setFilter({...curFilter, [elem.key]: event.currentTarget.value});
                        setCurrentPage(1);
                    }}
                    options = {{ 
                        blocks:[3, 3, 4],
                        delimiter: "-",
                        numericOnly: true,
                    }}
                />
                :<></>}
                {elem.type === "select"?
                <>
                <input
                    id = {elem.filterKey || elem.key}
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[elem.filterKey || elem.key] ?? ""}
                    onChange = {event => {
                        setFilter({
                            ...curFilter,
                            [elem.filterKey || elem.key]: event.currentTarget.value
                        });
                        setCurrentPage(1);
                    }}
                    list = {elem.title + " list"}
                    autoComplete = "off"
                />
                <datalist id = {elem.title + " list"}>
                    {(elem.filterOptions || elem.options)?.map((option, optionIndex) => <option key = {optionIndex} value = {option.value}/>)}
                </datalist>
                </>:<></>}
                {elem.type === "date"?<>
                <label htmlFor = {elem.key + "Max"} className = "ml-3">after:</label>
                <input
                    id = {elem.key + "Max"}
                    type = "date"
                    min = {elem.min || "1900-01-01"}
                    max = {curFilter[elem.key + "Max"] || "2999-12-31"}
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[elem.key + "Min"] ?? ""}
                    onChange = {event => {
                        setFilter({...curFilter, [elem.key + "Min"]: event.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label htmlFor = {elem.key + "Min"} className = "ml-3">before:</label>
                <input
                    id = {elem.key + "Min"}
                    type = "date"
                    min = {curFilter[elem.key + "Min"] || elem.min || "1900-01-01"}
                    max = {elem.max || "2999-12-31"}
                    className = "form-control flex-grow-1 ml-3"
                    value = {curFilter[elem.key + "Max"] ?? ""}
                    onChange = {event => {
                        setFilter({...curFilter, [elem.key + "Max"]: event.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />  
                </>:<></>}
                {elem.type === "number"?<>
                <label htmlFor = {elem.key + "Max"} className = "ml-3">min:</label>
                <input
                    id = {elem.key + "Max"}
                    type = "number"
                    step = {elem.step}
                    min = {elem.min}
                    max = {curFilter[elem.key + "Max"] || elem.max}
                    className = "form-control numberInputWidth flex-grow-1 ml-3"
                    value = {curFilter[elem.key + "Min"] ?? ""}
                    onChange = {event => {
                        setFilter({...curFilter, [elem.key + "Min"]: event.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <label htmlFor = {elem.key + "Min"} className = "ml-3">max:</label>
                <input
                    id = {elem.key + "Min"}
                    type = "number"
                    step = {elem.step}
                    min = {curFilter[elem.key + "Min"] || elem.min}
                    max = {elem.max}
                    className = "form-control numberInputWidth flex-grow-1 ml-3"
                    value = {curFilter[elem.key + "Max"] ?? ""}
                    onChange = {event => {
                        setFilter({...curFilter, [elem.key + "Max"]: event.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                </>:<></>}
                {!["date", "number"].includes(elem.type) && curFilter[elem.filterKey || elem.key] !== defaultFilter[elem.filterKey || elem.key]?
                <button
                    type = "button"
                    className = "noButtonStyle ml-2"
                    onClick = {() => {
                        setFilter({
                            ...curFilter, 
                            [elem.filterKey || elem.key]: defaultFilter[elem.filterKey || elem.key]
                        })
                    }}
                >
                    ❌
                </button>
                :<></>}
                {["date", "number"].includes(elem.type) &&
                (curFilter[elem.key + "Max"] !== defaultFilter[elem.key + "Max"] || curFilter[elem.key + "Min"] !== defaultFilter[elem.key + "Min"])?
                <button
                    type = "button"
                    className = "noButtonStyle ml-2"
                    onClick = {() => {
                        setFilter({
                            ...curFilter, 
                            [elem.key + "Min"]: defaultFilter[elem.key + "Min"], 
                            [elem.key + "Max"]: defaultFilter[elem.key + "Max"]
                        })
                    }}>
                        ❌
                    </button>
                :<></>}
            </div>
            )}
            <div className = "mt-3 mb-3">
                <button type = "button" className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</button>
            </div>
        </Modal>:<></>}
        </>
    )
}